import { FC } from 'react'

export const ThreeDotsLoader: FC = () => (
  <div className="flex items-center justify-center gap-2">
    <span className="sr-only">...</span>
    <div className="bg-primary-base size-1 animate-bounce rounded-full [animation-delay:-0.3s]"></div>
    <div className="bg-primary-base size-1 animate-bounce rounded-full [animation-delay:-0.15s]"></div>
    <div className="bg-primary-base size-1 animate-bounce rounded-full"></div>
  </div>
)
